import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconClose from '../IconClose';
import IconSearch from '../IconSearch';
import { ENTER_KEY, MIN_SEARCH_SYMBOLS_COUNT, POPULAR_SEARCHES_COUNT } from '../../../consts';

import { textBlack, grayLight } from '../../../styles/scss/_colors.scss';
import styles from './index.scss';

class SearchInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFocused: false,
            headerHeight: '',
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleEventOutside);
        this.sdlHeader = document.querySelector('.sdl-header-global');
        if (this.sdlHeader) {
            this.watchHeader(this.sdlHeader);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleEventOutside);
    }

    handleInputChange = event => {
        if (this.props.inputValue !== event.target.value) {
            this.props.onChange(event.target.value);
        }
    };

    handleInputClear = () => {
        this.props.onClear();
        if (this.elInput) {
            this.elInput.focus();
        }
        // if (this.state.isFocused) {
        //     this.setState({ isFocused: false });
        // }
    };

    handleKeyDown = event => {
        if (event.keyCode === ENTER_KEY) {
            this.props.redirectTo();
        }
    };

    handleInputFocus = ev => {
        ev.preventDefault();
        ev.currentTarget.focus();
        const { inputValue, openDropDown, addPopularSearches } = this.props;

        if (inputValue.length === POPULAR_SEARCHES_COUNT) {
            addPopularSearches();
            openDropDown();
        }

        if (ev.currentTarget === document.activeElement) {
            this.setState({ isFocused: true });
        }

        if (inputValue.length >= MIN_SEARCH_SYMBOLS_COUNT) {
            openDropDown();
        }
    };

    handleEventOutside = ev => {
        if (
            !this.searchInputWrapRef ||
            (ev.target !== this.searchInputWrapRef && !this.searchInputWrapRef.contains(ev.target))
        ) {
            this.setState({ isFocused: false });
        }
    };

    handleSearchIconClick = () => {
        this.props.searchButtonClick();
        if (!this.props.inputValue) {
            this.setState({ isFocused: false });
        }

        this.props.redirectTo();
    };

    // Fix for IE (closing dropdown when gray overlay is being clicked)
    handleInputBlur = () => {
        if (this.elInput) {
            this.elInput.blur();
        }
        const { closeDropDown } = this.props;
        closeDropDown();
    };

    watchHeader = header => {
        const config = {
            attributes: true,
        };
        const callback = mutationList => {
            // eslint-disable-next-line no-restricted-syntax
            for (const mutation of mutationList) {
                if (
                    mutation.target.classList.contains('reduced') ||
                    mutation.target.classList.contains('increased')
                ) {
                    const headerHeight = mutation.target.style.height;
                    if (headerHeight && this.state.headerHeight !== headerHeight) {
                        this.setState({ headerHeight });
                    }
                }
            }
        };
        this.observer = new MutationObserver(callback);
        this.observer.observe(header, config);
    };

    render() {
        const { isFocused, headerHeight } = this.state;
        const { inputValue, translationsMap } = this.props;

        const searchInputBtnStyles = classNames({
            [styles.searchInput__searchButton]: true,
            [styles.searchInput__searchButton_active]: inputValue.length,
            'analytics-navigation': true,
        });
        const searchInputStyles = classNames({
            [styles.searchInput__field]: true,
            'analytics-input': true,
        });

        return (
            <div>
                <div
                    className={styles.searchInput}
                    ref={searchInputWrap => {
                        this.searchInputWrapRef = searchInputWrap;
                        return null;
                    }}
                >
                    <input
                        type="text"
                        placeholder={translationsMap['search.fss.label.searchBox']}
                        value={inputValue}
                        ref={el => {
                            this.elInput = el;
                        }}
                        className={searchInputStyles}
                        onInput={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                        onKeyDown={this.handleKeyDown}
                    />
                    <div className={styles.searchInput__controlButtons}>
                        {inputValue.length && isFocused ? (
                            <div
                                className={styles.searchInput__closeButton}
                                onClick={this.handleInputClear}
                            >
                                <IconClose />
                            </div>
                        ) : null}
                        <div className={searchInputBtnStyles} onClick={this.handleSearchIconClick}>
                            <IconSearch fill={`${inputValue.length ? textBlack : grayLight}`} />
                        </div>
                    </div>
                </div>
                {isFocused ? (
                    <div
                        className={styles.searchInput__overlay}
                        onMouseDown={this.handleInputBlur}
                        style={headerHeight ? { top: headerHeight } : {}}
                    />
                ) : null}
            </div>
        );
    }
}

SearchInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    openDropDown: PropTypes.func.isRequired,
    inputValue: PropTypes.string.isRequired,
    translationsMap: PropTypes.object.isRequired,
    redirectTo: PropTypes.func.isRequired,
    closeDropDown: PropTypes.func.isRequired,
    addPopularSearches: PropTypes.func.isRequired,
    searchButtonClick: PropTypes.func.isRequired,
};

export default SearchInput;
